"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("./Box"));

var _theme = _interopRequireDefault(require("./theme"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var boxShadow = function boxShadow(props) {
  var boxShadows = {
    sm: _theme["default"].boxShadows[0],
    md: _theme["default"].boxShadows[1],
    lg: _theme["default"].boxShadows[2],
    xl: _theme["default"].boxShadows[3]
  };
  return {
    boxShadow: boxShadows[props.boxShadowSize]
  };
};

var boxBorder = function boxBorder(props) {
  return {
    border: props.borderWidth > 0 ? "".concat(props.borderWidth, "px solid ").concat(props.theme.colors[props.borderColor]) : null
  };
};

var Card = (0, _styledComponents["default"])(_Box["default"])([], boxShadow, boxBorder, _styledSystem.borderRadius);
Card.propTypes = _objectSpread({
  /** use scale alias for theme values or null to remove shadow */
  boxShadowSize: _propTypes["default"].oneOf([null, 'sm', 'md', 'lg', 'xl']),
  borderColor: _propTypes["default"].string
}, _styledSystem.propTypes.borderRadius, {
  /** use 0 to remove border */
  borderWidth: _propTypes["default"].oneOf([0, 1, 2])
});
Card.defaultProps = {
  theme: _theme["default"],
  borderColor: 'smoke',
  borderRadius: 1,
  borderWidth: 0
};
Card.displayName = 'Card';
var _default = Card;
exports["default"] = _default;